import React from 'react';
import PropTypes from 'prop-types';
import styles from '../Price.scss';
import language from "@lang/language";

const PriceDefault = ({priceData, color = ''}) => {
	if (!priceData) {
		return null;
	}

	return (
	  <div className={`${styles.container} ${color ? styles[color] : ''}`}>
		  <div className={styles.priceFrom}>
			  {language.from}
		  </div>

		  <div className={styles.prices}>
			  <div className={styles.priceContainer}>
				  <div className={styles.price}>
					  {priceData.price}
				  </div>
				  <div>
					  {priceData.text}
				  </div>
			  </div>
		  </div>
	  </div>
	);
}

PriceDefault.propTypes = {
	priceData: PropTypes.object.isRequired,
	color: PropTypes.string
};

export default PriceDefault;
